import { Routes } from '@angular/router';

/** Extra routes for the active build. Other brands supply a replacement file. */
export const flavourAppRoutes: Routes = [];

export const flavourHomeRoutes: Routes = [];

/** Chat routes that exist only for this brand. */
export const flavourChatRoutes: string[] = [];

/** Full-screen routes that exist only for this brand. */
export const flavourFullScreenRoutes: string[] = [];

/** Document-title matches that exist only for this brand. */
export const flavourPageTitleKeys: Array<{ match: string; key: string }> = [];
